import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_cards_to_list';
export const useAttachCardToListTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ru = ({
  [keyPrefix]: {
    toast_success: 'Карточки успешно добавлены',
    toast_error: 'Не удалось прикрепить карточки к списку',
    attach_button: 'Добавить в список',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'Cards added successfully',
    toast_error: 'Failed to attach cards to list',
    attach_button: 'Attach to list',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Cartões adicionados com sucesso',
    toast_error: 'Não foi possível anexar os cartões à lista',
    attach_button: 'Anexar à lista',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Tarjetas añadidas con éxito',
    toast_error: 'No se pudieron adjuntar las tarjetas a la lista',
    attach_button: 'Adjuntar a la lista',
  },
}) as Record<string, unknown>;
